import dynamic from "next/dynamic";
import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "next-i18next";
import { array, boolean, mixed, object, string } from "yup";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import Swal from "sweetalert2";
import { isExists } from "../../utils";
import { useRouter } from "next/router";
import { clean } from "../../utils";
import { mailBody } from "./components/mailbody";
import EmailInput from "../inputs/EmailInput";
export const email_regex = /[ğüşöçıİĞÜŞÖÇ]/;

const RecaptchaInput = dynamic(() => import("../inputs/RecaptchaInput"), {
  ssr: false,
});
const AnchorLink = dynamic(() => import("../anchor/Anchor"), {
  ssr: false,
});
const Checkbox = dynamic(() => import("../inputs/CheckBoxInput"), {
  ssr: false,
});
const SelectInput = dynamic(() => import("../inputs/SelectInput"), {
  ssr: false,
});
const TextAreaInput = dynamic(() => import("../inputs/TextAreaInput"), {
  ssr: false,
});
const TextInput = dynamic(() => import("../inputs/TextInput"), {
  ssr: false,
});

const AddressSelectInput = dynamic(
  () => import("../inputs/AddressSelectInput"),
  {
    ssr: false,
  }
);
const PhoneInput = dynamic(() => import("../inputs/PhoneInput"), {
  ssr: false,
});

export const communicationTypeEnum = {
  e_mail: 1,
  mobile: 2,
  // sms: 3,
  // phone: 4,
};

const FormForService = ({ productId }) => {
  const { locale } = useRouter();
  const router = useRouter();
  const [loader, setLoader] = useState(true);

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [token, setToken] = useState();
  const [products, setProducts] = useState();
  const [adSource, setAdSource] = useState();
  const option = null;

  const initialValues = {
    option: "1",
    productNames: [],
    customerTypeId: 1,
    customerKindId: "1",
    commercialTitle: "",
    alias: "",
    name: "",
    surname: "",
    email: "",
    customerDetail: {
      creationSource: "İŞNET",
      kvkkMarkApprovalEmail: "",
      conditionId: process.env.NEXT_PUBLIC_CUSTOMER_CONDITION,
      statusId: process.env.NEXT_PUBLIC_CUSTOMER_STATUS,
      isActive: true,
      description: "",
      //adSourceId: "28b0088c-08c3-44c9-8d19-08da3dbc8ef3",
      adSourceId: "00000001-0000-0000-0000-000000000000",
      iys: false,
    },

    contact: {
      name: "",
      surname: "",
      titleId: 1,
      jobTitleId: process.env.NEXT_PUBLIC_CUSTOMER_JOBTITLEID,
      nationalityId: process.env.NEXT_PUBLIC_CUSTOMER_NATIONALITY,
      kvkkMarkApprovalMailSend: false,
      kvkkMarkApprovalSmsSend: false,
      isBlueCardCitizen: false,
      isAuthorizedSignature: false,
      iys: true,
      contactCommunication: [
        {
          value: "",
          description: "",
          communicationTypeId: 1,
          contactCommunicationPermission: [
            { notificationId: 1, approval: false },
            { notificationId: 2, approval: false },
            { notificationId: 3, approval: false },
            { notificationId: 4, approval: false },
            { notificationId: 5, approval: false },
          ],
        },
        {
          value: "",
          description: "",
          communicationTypeId: 2,
          contactCommunicationPermission: [
            { notificationId: 1, approval: false },
            { notificationId: 2, approval: false },
            { notificationId: 3, approval: false },
            { notificationId: 4, approval: false },
            { notificationId: 5, approval: false },
          ],
        },
      ],
    },
    recaptcha: "",
    cityId: "",
    townId: "",
    townName: "",
    cityName: "",
    activityInterestedServiceCreateList: [productId],
  };
  var initialActivityValues = {
    contactId: "",
    ownerId: process.env.NEXT_PUBLIC_OWNERID,
    activityDate: new Date(),
    subject: "Ürün Başvuru Formu",
    description: "",
    customerId: "",
    activityReasonId: process.env.NEXT_PUBLIC_CUSTOMER_ACTIVITYREASON,
    activityResultId: process.env.NEXT_PUBLIC_CUSTOMER_ACTIVITYRESULT,
    activityTypeId: process.env.NEXT_PUBLIC_CUSTOMER_ACTIVITYTYPE,
    creatorEmail: process.env.USERNAMEMAIL,
    activityDetail: {
      activityCommunicationTypeId: 1,
    },
    activityInterestedServiceCreateList: [
      {
        interestedServiceSku: "",
      },
    ],
  };

  const getToken = useCallback(async () => {
    const auth = await fetch(`${process.env.FIXITYURL}/Auth/Auth/CreateToken`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "isnet_prod@is.net.tr",
        password: "1q2w3e4R*",
      }),
    });
    const authData = auth.ok ? await auth.json() : null;
    const token = authData ? authData.data.accessToken : null;
    setToken(token);
    return token;
  }, []);

  const getProducts = useCallback(
    async (token) => {
      const response = await fetch(
        `${process.env.FIXITYURL}/catalog/ProductType/get-list-dropdown?size=1000&pageNumber=0&isDeleted=false`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }
      setLoader(false);
      return await response.json();
    },
    [token]
  );

  const getAdSources = useCallback(
    async (token) => {
      const response = await fetch(
        `${process.env.FIXITYURL}/customer/adSource?size=1000&pageNumber=0&isDeleted=false`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }
      return await response.json();
    },
    [token]
  );

  useEffect(() => {
    const token = getToken();
    token.then(async (data) => {
      const productsData = await getProducts(data);

      let preparedData = [];
      if (productsData?.data) {
        for (let i = 0; i < productsData.data.length; i++) {
          const e = productsData.data[i];
          if (e.showWebsite) {
            e.name = e.categoryName + " - " + e.customerProductTypeName;
            preparedData.push(e);
          }
        }
      }
      const collator = new Intl.Collator("tr");

      let newProducts = preparedData?.sort((a, b) =>
        collator.compare(a.name.toUpperCase(), b.name.toUpperCase())
      );
      setProducts(newProducts);

      const dataAdSource = await getAdSources(data);
      const adSourceIds = dataAdSource?.data?.map((item) => ({
        name: item.name,
        value: item.id,
      }));
      setAdSource(adSourceIds);
    });
  }, [getToken]);

  const validationSchema = object({
    name: string().nullable().required(t("forms:nameRequired")),
    surname: string().nullable().required(t("forms:surnameRequired")),
    recaptcha: string().nullable().required(t("forms:recaptchaRequired")),
    customerDetail: object({
      adSourceId: string().nullable(),
      description: string().nullable(),
    }),
    contact: object({
      kvkkMarkApprovalMailSend: boolean().test(
        t("forms:kvkkRequired"),
        t("forms:kvkkRequired"),
        function () {
          if (this.parent.kvkkMarkApprovalMailSend !== true) return false;
          return true;
        }
      ),
      contactCommunication: array()
        .of(
          object().shape({
            value: mixed().when("communicationTypeId", {
              is: communicationTypeEnum.e_mail,
              then: () =>
                string()
                  .email(t("forms:validEmail"))
                  .required(t("forms:emailRequired"))
                  .test(
                    "turkish_chars",
                    t("forms:noTurkishChars"),
                    function () {
                      return email_regex.test(this.parent.value) ? false : true;
                    }
                  ),
              otherwise: () =>
                mixed().when("communicationTypeId", {
                  is: (communicationTypeId) =>
                    communicationTypeId === communicationTypeEnum.mobile,
                  then: () =>
                    string()
                      .required(t("forms:phoneRequired"))
                      .nullable()
                      .test(
                        "no_leading_zero",
                        t("forms:noLeadingZero"),
                        function () {
                          if (
                            this.parent.value &&
                            this.parent.value.startsWith("0")
                          )
                            return false;
                          return true;
                        }
                      )
                      .min(10, t("forms:phoneMinLength"))
                      .matches(/^[0-9]+$/, t("forms:onlyNumbers")),
                  otherwise: () =>
                    string()
                      .required(t("forms:emailRequired"))
                      .test(
                        "no_leading_zero",
                        t("forms:noLeadingZero"),
                        function () {
                          if (
                            this.parent.value &&
                            this.parent.value.startsWith("0")
                          )
                            return false;
                          return true;
                        }
                      )
                      .test(
                        "no_whitespace",
                        t("forms:noWhitespace"),
                        function () {
                          if (this.parent.value && /\s/.test(this.parent.value))
                            return false;
                          return true;
                        }
                      ),
                }),
            }),
          })
        )
        .nullable(),
    }),
    activityInterestedServiceCreateList: array().min(
      1,
      t("forms:minOneProduct")
    ),
  });

  const submitHandler = (values, { setSubmitting }) => {
    // Critical security check: Ensure reCAPTCHA is completed
    if (!values.recaptcha) {
      Swal.fire(
        t("forms:errorOccurred"),
        t("forms:recaptchaRequired"),
        "error"
      );
      setSubmitting(false);
      return;
    }

    setLoading(true);
    const val = {
      customerTypeId: 1,
      customerKindId: values.commercialTitle ? 2 : 1,
      commercialTitle: values.commercialTitle,
      alias: values.commercialTitle
        ? values.commercialTitle
        : values.name + " " + values.surname,
      name: values.name,
      surname: values.surname,
      email: values.contact.contactCommunication[0].value,
      customerDetail: {
        creationSource: "İŞNET",
        conditionId: process.env.NEXT_PUBLIC_CUSTOMER_CONDITION,
        statusId: process.env.NEXT_PUBLIC_CUSTOMER_STATUS,
        isActive: true,
        description: "",
        //adSourceId: "270fece1-916e-4b45-8d1f-08da3dbc8ef3",
        adSourceId: values.customerDetail.adSourceId, //canlıya çıkmayacak
        iys: values.customerDetail.iys,
      },
      contact: [
        {
          name: values.name,
          surname: values.surname,
          titleId: 1,
          jobTitleId: process.env.NEXT_PUBLIC_CUSTOMER_JOBTITLEID,
          nationalityId: process.env.NEXT_PUBLIC_CUSTOMER_NATIONALITY,
          kvkkMarkApprovalEmail: values.contact.contactCommunication[0].value,
          kvkkMarkApprovalMailSend: values.contact.kvkkMarkApprovalMailSend,
          kvkkMarkApprovalSmsSend: false,
          isBlueCardCitizen: false,
          isAuthorizedSignature: false,
          iys: values.customerDetail.iys,
          contactCommunication: [
            {
              value: values.contact.contactCommunication[0].value,
              description: "",
              communicationTypeId: 1,
              contactCommunicationPermission: [
                { notificationId: 1, approval: false },
                { notificationId: 2, approval: false },
                { notificationId: 3, approval: false },
                { notificationId: 4, approval: false },
                { notificationId: 5, approval: false },
              ],
            },
            {
              value: values.contact.contactCommunication[1].value,
              description: "",
              communicationTypeId: 2,
              contactCommunicationPermission: [
                { notificationId: 1, approval: false },
                { notificationId: 2, approval: false },
                { notificationId: 3, approval: false },
                { notificationId: 4, approval: false },
                { notificationId: 5, approval: false },
              ],
            },
          ],
        },
      ],
      activityInterestedServiceCreateList: [productId],
    };

    const customerName = values.commercialTitle
      ? values.commercialTitle
      : values.name + " " + values.surname;

    let contact = val.contact[0].name + " " + val.contact[0].surname;
    let mailData = { to: [], cc: [], products: [] };
    for (
      let i = 0;
      i < values.activityInterestedServiceCreateList.length;
      i++
    ) {
      const p = values.activityInterestedServiceCreateList[i];

      let product = products?.find((f) => f.id === p);
      if (
        isExists(product?.departmentEmail) &&
        product?.departmentEmail !== ""
      ) {
        let splitted = product.departmentEmail.split(";");
        for (let j = 0; j < splitted.length; j++) {
          const e = splitted[j];
          mailData.to.push(e.trim());
        }
      } else {
        mailData.to = ["musteri.hizmetleri@is.net.tr"];
      }
      if (
        isExists(product?.departmentCCEmail) &&
        product?.departmentCCEmail !== ""
      ) {
        let splitted = product?.departmentCCEmail?.split(";");
        for (let j = 0; j < splitted.length; j++) {
          const e = splitted[j];
          mailData.cc.push(e.trim());
        }
      } else {
        mailData.cc = ["musteri.hizmetleri@is.net.tr"];
      }
    }

    let selectedproducts = products.filter((f) =>
      values.activityInterestedServiceCreateList.includes(f.id)
    );
    //.map((m) => m.customerProductTypeName);

    var arrQuery = selectedproducts.map(function (el, idx) {
      return {
        customerProductTypeName: el.customerProductTypeName,
        categoryName: el.categoryName,
      };
    });

    var arrStr = encodeURIComponent(JSON.stringify(arrQuery));
    var arrStrProduct = JSON.stringify(
      arrQuery.map(
        (item) => item.categoryName + " - " + item.customerProductTypeName
      )
    );

    fetch(`${process.env.FIXITYURL}/customer/customer/create-customer-merlin`, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(clean(val)),
      method: "POST",
    })
      .then(async (response) => response.json())
      .then(async (createdCustomer) => {
        function guidToInt(guid) {
          const bytes = guid
            .replace(/-/g, "")
            .match(/.{2}/g)
            .map((hex) => parseInt(hex, 16));
          const buffer = new ArrayBuffer(4);
          const view = new DataView(buffer);
          bytes
            .slice(0, 4)
            .forEach((byte, index) => view.setUint8(index, byte));
          return view.getInt32(0);
        }
        const customerGuid = createdCustomer.data.customerId;
        const merlinId = guidToInt(customerGuid);
        if (createdCustomer.isSuccessful) {
          fetch(`${process.env.FIXITYURL}/notification/email`, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(
              clean({
                from: "no-reply@is.net.tr",
                fromName: "İşNet Başvuru Formu",
                to: mailData.to,
                cc: mailData.cc,
                subject: arrStrProduct,
                mailBody: mailBody
                  .replace("$$customer", customerName)
                  .replace("$$contact", contact)
                  .replace("$$product", arrStrProduct)
                  .replace(
                    "$$contactEmail",
                    values.contact.contactCommunication[0].value
                  )
                  .replace(
                    "$$contactPhone",
                    values.contact.contactCommunication[1].value
                  )
                  .replace("$$city", values.cityName)
                  .replace("$$town", values.townName)
                  .replace("$$description", values.customerDetail.description)
                  // .replace(
                  //   "$$fixityLink",
                  //   `<a href="http://fixity.isnet.net.tr/customers/${createdCustomer.data.customerId}/general">Fixity Üzerinde Görüntüle<a>`
                  // ),
                  .replace(
                    "$$merlinLink",
                    `<a href="http://merlin/Firma/Firma.aspx?idFirma=${merlinId}">Merlin Üzerinde Görüntüle<a>` // Canlıya çıkmayaca
                  ),
              })
            ),
            method: "POST",
          });

          const valActivityInterestedServiceCreateList =
            values.activityInterestedServiceCreateList.map((m) => {
              return { interestedServiceSku: m };
            });

          //initialActivityValues?.activityInterestedServiceCreateList = valActivityInterestedServiceCreateList

          initialActivityValues.customerId = createdCustomer.data.customerId;
          initialActivityValues.contactId = createdCustomer.data.contactId;
          initialActivityValues.description = values.customerDetail.description; // Canlıya çıkmayacak

          fetch(`${process.env.FIXITYURL}/customer/activity`, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(
              clean({
                ...initialActivityValues,
                activityInterestedServiceCreateList:
                  valActivityInterestedServiceCreateList,
              })
            ),
            method: "POST",
          }).then(async (activiyRespnse) => {
            if (activiyRespnse.ok) {
              const activityData = await activiyRespnse.json();
              const data = {
                customerId: createdCustomer.data.customerId,
                description: values.customerDetail.description,
              };
              setLoading(false);
              // fetch(`${process.env.FIXITYURL}/customer/preApplication`, {
              //   headers: {
              //     Authorization: "Bearer " + token,
              //     "Content-Type": "application/json",
              //   },
              //   body: JSON.stringify(data),
              //   method: "POST",
              // })
              //   .then((res) => res.json())
              // .then((data) => {
              const workOrderValues = {
                statusId: 1,
                typeId: 1,
                organizationGroupId: "00000015-0000-0000-0000-000000000000",
                isLocked: false,
                title: "Ürün Başvuru Talebi",
                description: `
                      Musteri:${
                        values.commercialTitle
                          ? values.commercialTitle
                          : values.name + " " + values.surname
                      }
                      Ürünler:
                      ${values.productNames}
                      Kullanıcı Açıklaması:
                      ${values.customerDetail.description}`,
                priorityId: 2,
                urgencyId: 1,
                customerId: data.customerId,
                isNotifyTheCustomer: false,
                detail: {
                  categoryId: "044d3bdb-c2c5-4ccb-f968-08da3d92af62",
                  actionFieldId: 1,
                  isDataBank: false,
                },
              };
              if (option === 2) {
                fetch(`${process.env.FIXITYURL}/workorder/workorder`, {
                  headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(workOrderValues),
                  method: "POST",
                })
                  .then((res) => res.json())
                  .then((data) => {
                    if (data.isSuccessful) {
                      const a = document.createElement("a");
                      a.href = `/tesekkurler-teknik-destek?success=0&form=urunbasvuruformu&products=${arrStr}&transactionId=${activityData.data}`;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      router.push(
                        `/tesekkurler-teknik-destek?success=0&form=urunbasvuruformu&products=${arrStr}&transactionId=${activityData.data}`
                      );
                    } else {
                      Swal.fire("Hata oluştu!", data.errors[0], "error");
                    }
                  });
              } else {
                const a = document.createElement("a");
                a.href = `/tesekkurler?success=0&form=urunbasvuruformu&products=${arrStr}&transactionId=${activityData.data}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                router.push(
                  `/tesekkurler?success=0&form=urunbasvuruformu&products=${arrStr}&transactionId=${activityData.data}`
                );
              }
            }
          });
        } else {
          setLoading(false);
          values.customerKindId = values.customerKindId.toString();
          Swal.fire("Hata oluştu!", "", "error");
        }
        // });
        // } else {
        //   Swal.fire("Hata oluştu!", createdCustomer.errors[0], "error");
        //   setLoading(false);
        // }
      });
  };

  return (
    <>
      <Container className="form_container">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={submitHandler}
        >
          {({ values, errors }) => (
            <Form className="form_application">
              <Row>
                <Col md={4}>
                  <div className="form_group">
                    <TextInput name="name" label={t("forms:name")} />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form_group">
                    <TextInput name="surname" label={t("forms:surname")} />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form_group">
                    <TextInput
                      name="commercialTitle"
                      label={t("forms:company")}
                    />
                  </div>
                </Col>
                {router.query.page === "idp-aas" ||
                router.query.page === "pam-aas" ||
                router.query.page === "bulut-cagri-merkezi" ||
                router.query.page === "yonetilen-call-manager" ? null : (
                  <>
                    <Col md={4}>
                      <div className="form_group">
                        <AddressSelectInput
                          label={t("preApplication:city")}
                          name="cityId"
                          placeholder={t("preApplication:city")}
                          optionValue="turkTelekomId"
                          secondField={{
                            name: "cityName",
                            value: "name",
                          }}
                          endpoint="setting/TurkTelekomAddress/get-cities/187cf1ae-023f-ed11-a5f4-005056a2cd35"
                          token={token}
                        />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="form_group">
                        <AddressSelectInput
                          label={t("preApplication:town")}
                          name="townId"
                          placeholder={t("preApplication:town")}
                          optionValue="turkTelekomId"
                          secondField={{
                            name: "townName",
                            value: "name",
                          }}
                          endpoint="setting/TurkTelekomAddress/get-towns-by-city-id"
                          param={{
                            id: "cityId",
                            value: values?.cityId,
                          }}
                          skip={!isExists(values?.cityId)}
                          disabled={!isExists(values?.cityId)}
                          token={token}
                        />
                      </div>
                    </Col>
                  </>
                )}
                <Col md={4}>
                  <PhoneInput
                    name="contact.contactCommunication[1].value"
                    label={t("forms:phone")}
                  />
                </Col>
                <Col md={4}>
                  <div className="form_group">
                    <EmailInput
                      name="contact.contactCommunication[0].value"
                      label={t("forms:email")}
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form_group">
                    <TextAreaInput
                      name="customerDetail.description"
                      label={t("forms:description")}
                      rows={1}
                      style={{ height: "50px" }}
                    />
                  </div>
                </Col>

                <Col md={4} style={{ marginBottom: "30px" }}>
                  {adSource && locale === "tr" ? (
                    <SelectInput
                      isClearable={true}
                      name="customerDetail.adSourceId"
                      label={t("forms:adSourceId")}
                      options={adSource}
                      optionValue="value"
                    />
                  ) : null}
                </Col>
                <Col md={12}>
                  <div className="form_group">
                    <Checkbox
                      name="contact.kvkkMarkApprovalMailSend"
                      text={
                        <>
                          {locale === "tr" ? (
                            <>
                              <AnchorLink href="/kisisel-verilerin-korunmasi">
                                "Kişisel Verilerin Korunması ve İşlenmesi
                                Hakkındaki Aydınlatma Metnini"
                              </AnchorLink>
                              okudum anladım.
                            </>
                          ) : (
                            <>
                              I have read and approved the
                              <AnchorLink href="/kisisel-verilerin-korunmasi">
                                Personal Data Protection Policy
                              </AnchorLink>
                            </>
                          )}
                        </>
                      }
                    ></Checkbox>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="form_group">
                    <Checkbox
                      name="customerDetail.iys"
                      text={
                        <>
                          {locale == "tr" ? (
                            <>
                              <AnchorLink href="/elektronik-ticari-ileti-acik-riza-metni">
                                Elektronik Ticari İleti Açık Rıza Metni
                              </AnchorLink>
                              ni okudum, kabul ediyorum.
                            </>
                          ) : (
                            <>
                              I have read and the
                              <AnchorLink href="/elektronik-ticari-ileti-acik-riza-metni">
                                Electronic Commercial Message Express Consent
                                Text
                              </AnchorLink>
                            </>
                          )}
                        </>
                      }
                    ></Checkbox>
                  </div>
                </Col>
                <Col md={12}>
                  <RecaptchaInput name="recaptcha" />
                </Col>
              </Row>
              <Row gap={2} justify="center">
                <Col
                  className="text-center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 20,
                  }}
                >
                  {!loader ? (
                    <>
                      {loading && (
                        <div>
                          <Spinner
                            animation="border"
                            variant="primary"
                            style={{ marginRight: 15, marginTop: 5 }}
                          />
                        </div>
                      )}
                      <button
                        disabled={loading}
                        type="submit"
                        className="btn btn-default"
                      >
                        {t("forms:send_btn")}
                      </button>
                    </>
                  ) : (
                    <div>
                      <Spinner
                        animation="border"
                        variant="primary"
                        style={{ marginRight: 15, marginTop: 5 }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    </>
  );
};

export default FormForService;
